export default __webpack_public_path__ + "1abf9ff61dda543ef199349e24806a70.png";